import styled from "styled-components";

export const Wrapper = styled.div`
    margin: 10px auto;
    background-color: lightgrey;
    border-radius: 5px;
    padding: 15px;
   
`

export const Content = styled.div`

    margin: 5px;
    border-radius: 10px;
    background-color: white;
   
    text-align: center;
    
    

    @keyframes rotate_card {
    from{transform: rotateX(360deg);}
        
    }


` 
export const Vraagstyle = styled.div`
    background-color: ${props => (props.korrek===true ? 'lightgreen':'red')};
    animation: rotate_card 1s ${props=>(props.korrek===false ? 'infinite': "")} ;
    border-radius: 20px;
    padding: 5px;
    box-shadow: inset -3px -3px 5px gray;
    display: grid;
    grid-auto-flow: column;
` 